import { Button, Dialog, Grid, Table, TableBody, TableCell, TableHead, TableRow, useMediaQuery, useTheme } from '@material-ui/core';
import { range } from 'lodash';
import moment from 'moment';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { _T } from '../../../../../include/appI18n';
import appSettings from '../../../../../include/appSettings';
import { formatMoney } from '../../../../../include/utils';
import { useTourExtras, useTourVariant } from '../../../store/TourDescriptionStore';
import { getExtraKey } from '../../../store/utils';
import { useFlightVariantsStyles } from '../FlightVariants/FlightVariants';
import { ExtrasDialog } from './ExtrasDialog';
const mandatoryExtrasDialogStorageKey = 'tourMandatoryExtrasDialogSeen';
const getMandatoryExtrasDialogSeen = () => {
    const windowWithFlags = window;
    if (windowWithFlags.__tourMandatoryExtrasDialogSeen)
        return windowWithFlags.__tourMandatoryExtrasDialogSeen;
    let seen = {};
    try {
        seen = JSON.parse(sessionStorage.getItem(mandatoryExtrasDialogStorageKey) || '{}') || {};
    }
    catch (_a) {
    }
    windowWithFlags.__tourMandatoryExtrasDialogSeen = seen;
    return seen;
};
const isMandatoryExtrasDialogSeen = (key) => {
    return !!key && !!getMandatoryExtrasDialogSeen()[key];
};
const markMandatoryExtrasDialogSeen = (key) => {
    if (!key)
        return;
    const seen = getMandatoryExtrasDialogSeen();
    if (seen[key])
        return;
    seen[key] = true;
    try {
        sessionStorage.setItem(mandatoryExtrasDialogStorageKey, JSON.stringify(seen));
    }
    catch (_a) {
    }
};
const getMandatoryExtrasDialogKey = (price, hash, mandatoryGroups) => {
    var _a;
    if (!price || !mandatoryGroups.length)
        return undefined;
    const hotelKey = ((_a = price.hotels) === null || _a === void 0 ? void 0 : _a.length)
        ? price.hotels.map(hotel => hotel.hotelId).join(',')
        : hash;
    const mandatoryKey = mandatoryGroups
        .map(group => group.map(service => getExtraKey(service)).join(','))
        .join('|');
    return [price.packageId, price.tourVariantId, price.date, price.duration, hotelKey, mandatoryKey].filter(x => !!x).join(':');
};
export const getExtraCost = (key, extras, price, tourVariant) => {
    const allMens = [...range(0, tourVariant.adultCount).map(x => 18), ...tourVariant.childAges];
    let cost = 0;
    const extraMens = extras[key];
    if (!(extraMens === null || extraMens === void 0 ? void 0 : extraMens.length))
        return 0;
    const services = price.extras.filter(x => getExtraKey(x) == key);
    for (let service of services) {
        const mensInService = allMens.map((value, index) => ({ value, index })).filter(x => x.value >= service.ageFrom && x.value < service.ageTo && extraMens.findIndex(m => m == x.index) >= 0).length;
        if (!mensInService)
            continue;
        cost += service.costEntityWithPromo.total * (service.isGroupCost ? 1 : mensInService);
    }
    return cost;
};
export function ExtrasContainer({ isFrame, onChange }) {
    var _a, _b;
    const [{ price, hash, extras, prevExtras }, { updateExtra, reloadExtras, getTourCost }] = useTourExtras(isFrame);
    //const [prevExtras, setPrevExtras] = useState<Record<string, number[] | undefined>>({});
    const [{ tourVariant }] = useTourVariant(isFrame);
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const classes = useFlightVariantsStyles();
    const [dialogOpen, setDialogOpen] = useState(false);
    const dialogRef = useRef(null);
    const mandatoryGroups = useMemo(() => { var _a, _b; return (_b = (_a = price === null || price === void 0 ? void 0 : price.mandatoryExtras) === null || _a === void 0 ? void 0 : _a.filter(group => !!(group === null || group === void 0 ? void 0 : group.length))) !== null && _b !== void 0 ? _b : []; }, [price === null || price === void 0 ? void 0 : price.mandatoryExtras]);
    const hasMandatoryExtras = !!mandatoryGroups.length;
    const hasAnyExtras = !!((_a = price === null || price === void 0 ? void 0 : price.extras) === null || _a === void 0 ? void 0 : _a.length) || hasMandatoryExtras;
    const mandatoryExtrasDialogKey = useMemo(() => getMandatoryExtrasDialogKey(price, hash, mandatoryGroups), [price, hash, mandatoryGroups]);
    const currencyRate = !appSettings().currencySwitchEnabled && (price === null || price === void 0 ? void 0 : price.exchangeRate) ? price.exchangeRate : 1;
    const currency = !appSettings().currencySwitchEnabled && (price === null || price === void 0 ? void 0 : price.exchangeRate) ? 'RUB' : price === null || price === void 0 ? void 0 : price.currency;
    const getMandatoryServiceMens = (service) => {
        var _a;
        if ((_a = service.availableMens) === null || _a === void 0 ? void 0 : _a.length)
            return service.availableMens;
        const allMens = [...range(0, tourVariant.adultCount).map(x => 18), ...tourVariant.childAges];
        return allMens
            .map((value, index) => ({ value, index }))
            .filter(x => x.value >= service.ageFrom && x.value <= service.ageTo)
            .map(x => x.index);
    };
    const getSelectedMandatoryService = (group) => {
        return group.find(service => { var _a; return !!((_a = extras[getExtraKey(service)]) === null || _a === void 0 ? void 0 : _a.length); })
            || group.find(service => service.preSelected)
            || group[0];
    };
    const selectedMandatoryServices = mandatoryGroups
        .map(group => getSelectedMandatoryService(group))
        .filter((service) => !!service);
    const getExtraCostInternal = useCallback((key) => {
        return Math.floor(getExtraCost(key, extras, price, tourVariant) * (!appSettings().currencySwitchEnabled && (price === null || price === void 0 ? void 0 : price.exchangeRate) ? price.exchangeRate : 1));
    }, [tourVariant, price, extras]);
    useEffect(() => {
        const keys = Object.keys(prevExtras);
        const extrasEqual = keys.length == Object.keys(extras).length
            && keys.every(p => { var _a, _b, _c; return prevExtras[p] == extras[p] || (((_a = prevExtras[p]) === null || _a === void 0 ? void 0 : _a.length) == ((_b = extras[p]) === null || _b === void 0 ? void 0 : _b.length) && ((_c = prevExtras[p]) === null || _c === void 0 ? void 0 : _c.every((x, i) => { var _a; return extras[p] && x === ((_a = extras[p]) === null || _a === void 0 ? void 0 : _a.at(i)); }))); });
        if (extrasEqual)
            return;
        //setPrevExtras({ ...extras });
        if (onChange)
            onChange(extras);
    }, [extras, onChange]);
    const closeDialog = useCallback(() => {
        if (hasMandatoryExtras)
            markMandatoryExtrasDialogSeen(mandatoryExtrasDialogKey);
        setDialogOpen(false);
    }, [hasMandatoryExtras, mandatoryExtrasDialogKey]);
    useEffect(() => {
        if (!hasMandatoryExtras || !mandatoryExtrasDialogKey || isMandatoryExtrasDialogSeen(mandatoryExtrasDialogKey))
            return;
        markMandatoryExtrasDialogSeen(mandatoryExtrasDialogKey);
        setDialogOpen(true);
    }, [hasMandatoryExtras, mandatoryExtrasDialogKey]);
    return (React.createElement(React.Fragment, null,
        hasAnyExtras ?
            React.createElement(Grid, { container: true, spacing: 2, alignItems: "center", className: classes.selectedFlightsTable },
                React.createElement("p", { className: "servicesHint text-grey w-100" }, _T.TOUR_EXTRAS_HINT),
                React.createElement(Grid, { item: true, xs: 12, className: `table-responsive` },
                    React.createElement(Table, { className: `table table-condensed cart-grid mb-0` },
                        React.createElement(TableHead, null,
                            React.createElement(TableRow, { className: `` },
                                React.createElement(TableCell, { className: `col-sm-4 col-md-5` }, _T.COMMON_GIVEN_NAME),
                                React.createElement(TableCell, { className: `col-sm-1 col-md-3` }, _T.COMMON_CLASS),
                                React.createElement(TableCell, { className: `col-sm-2 col-md-2` }, _T.COMMON_PERSONCOUNT),
                                React.createElement(TableCell, { className: `col-sm-3 col-md-2` }, _T.COMMON_PRICE),
                                React.createElement(TableCell, { className: `padding-left-0 width-18` }))),
                        React.createElement(TableBody, null, ((_b = Object.keys(extras)) === null || _b === void 0 ? void 0 : _b.length) || selectedMandatoryServices.length ?
                            React.createElement(React.Fragment, null,
                                Object.keys(extras).filter(key => { var _a, _b; return !!((_a = price === null || price === void 0 ? void 0 : price.extras) === null || _a === void 0 ? void 0 : _a.find(e => getExtraKey(e) == key)) && !!((_b = extras[key]) === null || _b === void 0 ? void 0 : _b.length); }).map(key => ({ key, services: price.extras.filter(e => getExtraKey(e) == key), mens: extras[key] })).map(({ key, services, mens }, index, array) => (React.createElement(TableRow, { key: index },
                                    React.createElement(TableCell, null,
                                        moment(tourVariant.checkInDate).add(services[0].day - 1, 'day').format('DD.MM'),
                                        " ",
                                        services[0].data.type,
                                        " ",
                                        services[0].data.name),
                                    React.createElement(TableCell, null, services[0].data.class),
                                    React.createElement(TableCell, null, mens.length),
                                    React.createElement(TableCell, null,
                                        formatMoney(getExtraCostInternal(key), { localeAware: true, currency: !appSettings().currencySwitchEnabled && (price === null || price === void 0 ? void 0 : price.exchangeRate) ? 'RUB' : price.currency }),
                                        " ",
                                        !appSettings().currencySwitchEnabled && (price === null || price === void 0 ? void 0 : price.exchangeRate) ? 'RUB' : price.currency),
                                    React.createElement(TableCell, { className: `padding-left-0` },
                                        React.createElement("i", { className: "delBtn", onClick: () => {
                                                updateExtra(key, undefined);
                                            }, title: _T.COMMON_DELETE }))))),
                                selectedMandatoryServices.map((service, index) => {
                                    var _a;
                                    const mens = (_a = extras[getExtraKey(service)]) !== null && _a !== void 0 ? _a : getMandatoryServiceMens(service);
                                    return (React.createElement(TableRow, { key: `mandatory-${index}` },
                                        React.createElement(TableCell, null,
                                            moment(tourVariant.checkInDate).add(service.day - 1, 'day').format('DD.MM'),
                                            " ",
                                            service.data.type,
                                            " ",
                                            service.data.name),
                                        React.createElement(TableCell, null, service.data.class),
                                        React.createElement(TableCell, null, mens.length),
                                        React.createElement(TableCell, null,
                                            formatMoney(Math.floor(service.costEntityWithPromo.roundTotal * currencyRate), { localeAware: true, currency }),
                                            " ",
                                            currency),
                                        React.createElement(TableCell, { className: `padding-left-0` })));
                                })) : null))),
                React.createElement(Grid, { item: true, xs: 12, container: true, justifyContent: "flex-end", alignItems: "center" },
                    React.createElement(Grid, { xs: "auto" },
                        React.createElement(Button, { className: classes.remainingPaymentTimeframeButton, onClick: () => setDialogOpen(true), variant: 'contained', color: 'primary', fullWidth: true }, _T.COMMON_ADD))))
            : null,
        React.createElement(Dialog, { ref: dialogRef, disablePortal: true, open: dialogOpen, maxWidth: fullScreen ? false : "md", fullWidth: true, fullScreen: fullScreen, scroll: 'body', onClose: closeDialog },
            React.createElement(ExtrasDialog, { dialogRef: dialogRef, isFrame: isFrame, onClose: closeDialog, getExtraCost: getExtraCostInternal }))));
}
